import React, { FC } from 'react';

// @ts-expect-error TS(2307) FIXME: Cannot find module 'graphql/tsutils/Maybe' or its ... Remove this comment to see the full error message
import Maybe from 'graphql/tsutils/Maybe';
import { GestureResponderEvent } from 'react-native';

export interface IWidgetElement {
  id: string;
  element: JSX.Element;
}

export enum LoyaltyInRestaurantRedemptionWidgets {
  Button = 'buttonWidget',
  Image = 'imageWidget',
  MarketingTiles = 'marketingTileGroupWidget',
  Text = 'textWidget',
  Title = 'titleWidget',
  ShortCodeWidget = 'shortCodeWidget',
  QrCodeLoyaltyIdWidget = 'qrCodeLoyaltyIdWidget',
  CartWidget = 'cartWidget',
  BasicCardWidget = 'basicCardWidget',
  PaymentMethodWidget = 'paymentMethodWidget',
  ButtonArray = 'loyaltyButtonArrayWidget',
}

export interface LoyaltyInRestaurantRedemptionViewProps {
  widgets: {
    topWidgets: Array<IWidgetElement>;
    bottomWidgets: Array<IWidgetElement>;
  };
}

export interface IRefreshCodeProps {
  onRefreshPress: (ev: GestureResponderEvent) => void;
  isCodeLoading: boolean;
  newUI?: boolean;
}

export interface LoyaltyInRestaurantRedemptionDrawerProps {
  isOpen?: boolean;
  onDismiss?: () => void;
  widgets: {
    topWidgets: Array<IWidgetElement>;
    bottomWidgets: Array<IWidgetElement>;
  };
}
export interface LoyaltyInRestaurantRedemptionContentProps {
  handleDismiss?: () => void;
  widgets: {
    topWidgets: Array<IWidgetElement>;
    bottomWidgets: Array<IWidgetElement>;
  };
}

export interface LoyaltyInRestaurantRedemptionDrawerProps {
  widgets: {
    topWidgets: Array<IWidgetElement>;
    bottomWidgets: Array<IWidgetElement>;
  };
}

export type Widget = FC<React.PropsWithChildren<Omit<IWidgetKey, 'componentKey'>>>;

export interface IWidgetElement {
  id: string;
  element: JSX.Element;
}

export type IWidgetMap<TWidgets extends string> = Record<TWidgets, Widget>;

export interface IWidgetKey {
  readonly componentKey?: Maybe<string>;
  readonly _key?: Maybe<string>;
  readonly [key: string]: any;
}

export const hasComponentKey = <T extends Object>(
  widget: Maybe<T & { componentKey?: Maybe<string> }>
): widget is T & { componentKey: string } => {
  return !!widget?.componentKey;
};
